import { Context } from "../core/auth/context";

export class ContextGroup {
    label: string = '';
    type: string = '';
    items: Context[] = [];

    constructor(label: string, type: string, items: Context[]) {
        this.label = label;
        this.type = type;
        this.items = items;
    }
}
